import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { baseFastApiMatterRoute } from "@/lib/data/requests/matters/matter";
import {
  type MatterLitigationDate,
  type APIResponse,
  type MatterLitigationDatePlan,
} from "@/lib/types";

type ApplyMatterLitigationDatePlanPayload = {
  dates: Array<
    Pick<MatterLitigationDate, "deadlineDate" | "typeId"> &
      Partial<
        Pick<MatterLitigationDate, "deadlineTime" | "description" | "status">
      >
  >;
  matterId: string;
  planId: MatterLitigationDatePlan["id"];
};

export const applyMatterLitigationDatePlanV1 = async (
  data: ApplyMatterLitigationDatePlanPayload,
) => {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<MatterLitigationDate[]>
    >(`${baseFastApiMatterRoute}/litigation-dates/plans/apply`, data)
    .then((res) => res.data);
};

export const createMatterLitigationDatePlanV1 = async (
  data: Pick<MatterLitigationDatePlan, "label" | "incidentState"> &
    Partial<MatterLitigationDatePlan>,
) => {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<MatterLitigationDatePlan>
    >(`${baseFastApiMatterRoute}/litigation-dates/plans`, data)
    .then((res) => res.data);
};

export const updateMatterLitigationDatePlanV1 = async (
  data: Pick<MatterLitigationDatePlan, "id" | "dateModified"> &
    Partial<MatterLitigationDatePlan>,
) => {
  return authenticatedFastApiAxiosInstance
    .patch<
      APIResponse<MatterLitigationDatePlan>
    >(`${baseFastApiMatterRoute}/litigation-dates/plans`, data)
    .then((res) => res.data);
};

export const deleteMatterLitigationDatePlanV1 = async (
  data: Pick<MatterLitigationDatePlan, "id">,
) => {
  const { id } = data;
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MatterLitigationDatePlan>
    >(`${baseFastApiMatterRoute}/litigation-dates/plans/${id}`)
    .then((res) => res.data);
};
